const styles = (theme) => ({
  layout: {
    position: 'relative',
    width: '100%',
    backgroundColor: theme.colors.header__background_primary,
    left: 0,
    top: theme.sizes.headerHeight,
    paddingTop: 65,
    transition: '225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    height: `calc(100vh - ${theme.sizes.headerHeight}px)`,
    'overflow-y': 'auto'
  },
  loading: {
    display: 'flex',
    paddingTop: 0,
    alignItems: 'center',
    justifyContent: 'center'
  },
  container: {
    width: 1128,
    marginLeft: 'auto',
    marginRight: 'auto'
  }
});

export default styles;
